import { api } from "./client";

export function getUsers(params?: { pageSize?: number; page?: number }) {
  return api.get<{
    data?: {
      users: {
        id: string;
        initials: string;
        full_name: string | null;
        role: string;
      }[];
    };
    users?: {
      id: string;
      initials: string;
      full_name: string | null;
      role: string;
    }[];
  }>("/users", { params });
}

export interface CreateUserResponse {
  user: {
    id: string;
    full_name: string;
    initials: string;
    role: string;
  };
  message: string;
}

export function createUser(data: {
  name: string;
  initials: string;
  password: string;
  role: string;
  mustChangePassword?: boolean;
  approvalToken?: string;
}) {
  return api.post<CreateUserResponse>("/users/create", {
    fullName: data.name,
    initials: data.initials,
    temporaryPassword: data.password,
    role: data.role,
    mustChangePassword: data.mustChangePassword ?? false,
    ...(data.approvalToken ? { approvalToken: data.approvalToken } : {}),
  });
}

export function updateUserRole(data: {
  userId: string;
  role: string;
  approvalToken?: string;
}) {
  return api.patch("/users/update-role", {
    userId: data.userId,
    newRole: data.role,
    ...(data.approvalToken ? { approvalToken: data.approvalToken } : {}),
  });
}

export function updateInitials(data: {
  userId: string;
  initials: string;
  approvalToken?: string;
}) {
  return api.patch("/users/update-initials", {
    userId: data.userId,
    initials: data.initials,
    ...(data.approvalToken ? { approvalToken: data.approvalToken } : {}),
  });
}

export function toggleUserStatus(data: {
  userId: string;
  isActive: boolean;
  approvalToken?: string;
}) {
  return api.patch("/users/toggle-status", {
    userId: data.userId,
    isActive: data.isActive,
    ...(data.approvalToken ? { approvalToken: data.approvalToken } : {}),
  });
}

export function updateProfile(data: { fullName?: string; initials?: string }) {
  return api.patch("/users/update-profile", data);
}

export function completeTour() {
  return api.patch("/users/complete-tour");
}

export function changePassword(data: {
  currentPassword: string;
  newPassword: string;
}) {
  return api.post("/users/change-password", data);
}

export function resetPassword(data: {
  userId: string;
  newPassword: string;
  approvalToken?: string;
}) {
  return api.post("/users/reset-password", {
    userId: data.userId,
    temporaryPassword: data.newPassword,
    ...(data.approvalToken ? { approvalToken: data.approvalToken } : {}),
  });
}
